module.exports = __webpack_public_path__ + "static/media/carole-baskin.f52bc845.mp3";